/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ActivityDetailsCtrl', function($scope, $location, identity) {
    $scope.me       = identity;

    $scope.selectStage = function(stage) {
        if ((stage.type != null) && (stage.type !== 'step')) {
            const stage_date = new Date(stage.start).getTime() / 1000;
            $location.search({ time: stage_date });
            return $location.path(`/user/${$scope.me.login}/planning`);
        } else {
            $scope.wall_type         = 'stage';
            $scope.params.stage_name = stage.name;
            $scope.collapsed_events  = false;
            $scope.current_stage     = stage;
            return $location.search({ stage: stage.name });
        }
    };

    return $scope.backToQuest = function() {
        $location.url($location.path());
        $scope.current_stage = undefined;
        $scope.wall_type     = 'activity';
        return delete $scope.params.stage_name;
    };
});
